<template>
    <section id="banner" :style="{ 'background-image': 'url(' + background + ')' }">
        <h1>{{ $t('evento.banner.titulo') }}</h1>
        <p>{{ $t('evento.banner.descricao') }}</p>
    </section>
</template>

<script>

import ImBackground from '@/assets/img/eventos/imagem-aerea-rio-de-janeiro.jpg'

export default {
    data () {
        return {
            background: ImBackground
        }
    }
}
</script>

<style lang="sass" scoped>
    @import "../../../assets/sass/_mixin"

    #banner
        height: 450px
        display: flex
        align-items: center
        justify-content: center
        flex-direction: column
        background-color: gray
        padding: 15px
        padding-top: 50px
        margin-bottom: 35px
        background-repeat: no-repeat
        background-size: cover
        background-position: center
        @include device(mobile)
            &
                height: 400px
        h1
            padding: 0
            font-size: 40px
            font-weight: 900
            line-height: 1
            margin: 10px 0
            color: white
            text-align: center
            text-shadow: 0px 0px 10px #00000061
            @include device(mobile)
                &
                    font-size: 36px

        p
            font-size: 21px
            max-width: 450px
            line-height: 1.2
            color: white
            text-align: center
            text-shadow: 0px 0px 10px #00000061
</style>
